import Headline from '@allesauto/core/headline';
import { sbEditable } from '@storyblok/storyblok-editable';
import clsx from 'clsx';

import TextImageBox, {
  ColorsObject,
  TextImageBoxProps,
  themes,
} from '../TextImageBox';

interface TextboxTextImageProps {
  headline?: string;
  headlineColor: keyof ColorsObject;
  descriptionColor: keyof ColorsObject;
  headlineFontSize?: 'title' | 'headline2' | 'headline3' | 'headline4';
  description?: string;
  _uid: string;
  component: string;
  tiles: TextImageBoxProps[];
  background: 'WHITE' | 'GREY';
  headlineTag: 2 | 3;
}

const cssClasses = {
  tilesContainer: 'mt-[24px] flex flex-col lg:flex-row',
  container: 'p-[24px] lg:p-[40px]',
};

const TextboxTextImage = (props: TextboxTextImageProps) => {
  const {
    headline,
    description,
    descriptionColor,
    tiles,
    background = 'WHITE',
    headlineColor,
    headlineFontSize,
    headlineTag,
  } = props;

  return (
    <section
      className={clsx(themes[background].background, cssClasses.container)}
      {...sbEditable(props)}
    >
      <div className="w-full">
        {headline && (
          <Headline
            headlineTag={headlineTag}
            headlineText={headline}
            headlineClassName={clsx(
              headlineFontSize && `text-${headlineFontSize}`
            )}
            headlineColor={themes[headlineColor].text}
            descriptionColor={themes[descriptionColor].text}
            descriptionText={description}
          />
        )}
        <div className={cssClasses.tilesContainer}>
          {tiles.map((textBox) => (
            <TextImageBox key={textBox._uid} {...textBox} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TextboxTextImage;
